<!--
 * @Description:
 * @Author: liXinMan
 * @Date: 2021-12-15 11:25:57
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-30 14:23:21
-->
<template>
	<div>
		<div class="pages-language">
			<div class="wrap">
				<div class="logo">
					<img :class="this.$i18n.locale" :src="require(`../assets/logo.gif`)" alt="#" />
				</div>
				<div class="btn-wrap">
					<div v-if="loading" class="loading">LOADING...</div>
					<el-row v-else :gutter="20">
						<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" style="text-align: center">
							<img src="../assets/comment/chinese-btn.png" alt="#" @click="changeChinese" />
						</el-col>
						<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
							<img src="../assets/comment/Russian-btn.png" alt="#" @click="changeRussian" />
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			canplay: this.$root.play,
			loading: false
		}
	},
	methods: {
		handelChange() {
			let music = document.getElementById('audio')
			this.canplay = !this.canplay
			this.$root.play = this.canplay
			if (!this.canplay) {
				music.pause()
			} else {
				music.play()
			}
		},
		changeChinese() {
			this.$i18n.locale = 'zh'
			this.$router.push({ name: 'PagesWorks' })
			localStorage.setItem('lang', this.$i18n.locale)
			this.handelChange()
		},
		changeRussian() {
			this.$i18n.locale = 'en'
			this.$router.push({ name: 'PagesWorks' })
			localStorage.setItem('lang', this.$i18n.locale)
			this.handelChange()
		}
	},
	mounted() {
		setTimeout(() => {
			this.loading = false
		}, 2000)
		this.$i18n.locale = localStorage.getItem('lang') || 'zh'
	}
}
</script>

<style lang="stylus">
.pages-language {
  position: relative;
  box-sizing: border-box;
  height: 100vh;
  width: 100vw;
  background: url('../assets/comment/main-bg.png') no-repeat;
  background-size: cover;
  padding-top: 100px;

  .bg-music {
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: 9999;
    width: 35px;
    height: 35px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .loading {
    text-align: center;
    color: #fff;
    font-size: 25px;
    font-weight: 700;
  }

  .wrap {
    width: 50%;
    margin: 100px auto;

    .logo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 50px;

      .zh {
        width: 500px;
        height: 220px;
        object-fit: contain;
      }

      .en {
        width: 500px;
        height: 220px;
        object-fit: contain;
      }
    }

    .btn-wrap {
      width: 100%;
      text-align: center;

      img {
        width: 180px;
        height: 60px;
        object-fit: contain;
        cursor: pointer;
      }
    }
  }
}

/* 手机 */
@media screen and (max-width: 600px) {
  .pages-language {
    background: url('../assets/mobileImagesBg/m-loading-bg.png') no-repeat;
    background-size: cover;
    padding-top: 50px;

    .wrap {
      .logo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          width: 90vw !important;
          object-fit: contain;
        }
      }

      .btn-wrap {
        width: 100%;
        text-align: center;

        img {
          width: 180px;
          height: 70px;
          cursor: pointer;
        }
      }
    }
  }
}

/* 平板 */
@media screen and (min-width: 600px) and (max-width: 960px) {
}
</style>
